<template>
    <div class="button-group">
        <button class="btn btn-success" @click="save"><i class="cil-chevron-right"> </i> Submit</button>
        <button class="btn btn-warning" @click="reset"><i class="cil-reload"> </i> Reset</button>
    </div>
</template>

<script>
    export default {
        name: "SRButton",
        methods: {
            save(evt) {
                this.$emit('onSave', evt);
            },
            reset(evt) {
                this.$emit('onReset', evt);
            }
        }
    }
</script>
